import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import ShieldImg from "../../Assets/Icons/shield.png";
import LoaderBox from "./LoaderBox";

const HomeLive = ({ turnirId }) => {
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeRoster, setActiveRoster] = useState(null);
  const [tournamentName, setTournamentName] = useState("FucaScore");
  const [countdownData, setCountdownData] = useState({
    enabled: false,
    target: null,
  });
  const [tournamentWinner, setTournamentWinner] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [hasVoted, setHasVoted] = useState(false);

  // Provjera je li korisnik već glasao za ovu utakmicu
  useEffect(() => {
    if (match?.id) {
      const votedStatus = localStorage.getItem(`voted_match_${match.id}`);
      setHasVoted(!!votedStatus);
    }
  }, [match?.id]);

  // Funkcija za glasanje
  // Privremeno bez localStorage provjere da možeš testirati koliko god želiš
  const handleVote = async (teamSide) => {
    if (!match || hasVoted) return; // Ako je već glasao, prekini odmah

    const columnToUpdate = teamSide === "A" ? "votes_a" : "votes_b";
    const currentVal =
      teamSide === "A" ? match.votes_a || 0 : match.votes_b || 0;
    const newVal = currentVal + 1;

    // 1. Zabilježi u localStorage da je korisnik glasao za ovu specifičnu utakmicu
    localStorage.setItem(`voted_match_${match.id}`, "true");
    setHasVoted(true);

    // 2. Instantno lokalno osvježenje da korisnik odmah vidi promjenu
    setMatch((prev) => ({
      ...prev,
      [columnToUpdate]: newVal,
    }));

    // 3. Pozivamo sigurnu funkciju u bazi
    const { error } = await supabase.rpc("increment_vote", {
      match_id: match.id,
      team_side: teamSide,
    });

    if (error) {
      console.error("Greška kod glasanja:", error);
    }
  };
  useEffect(() => {
    const fetchLiveMatch = async () => {
      if (!turnirId) {
        setLoading(false);
        return;
      }

      setLoading(true);

      const { data: settings } = await supabase
        .from("admin_turniri")
        .select("countdown_enabled, countdown_target, naziv")
        .eq("id", turnirId)
        .maybeSingle();

      if (settings) {
        if (settings.naziv) {
          setTournamentName(settings.naziv);
        }
        setCountdownData({
          enabled: settings.countdown_enabled || false,
          target: settings.countdown_target || null,
        });
      }

      // 1. Prvo saznajemo veličinu turnira (senior size) da znamo koji slot je finale
      const { data: turnirSettings } = await supabase
        .from("admin_turniri")
        .select("championship_size")
        .eq("id", turnirId)
        .maybeSingle();

      const champSize = turnirSettings?.championship_size || 16;
      const finalSlotId = champSize === 16 ? 15 : champSize === 8 ? 7 : 3;

      // 2. Tražimo ISKLJUČIVO utakmicu finala za taj slot
      const { data: finalMatchData } = await supabase
        .from("turniri_utakmice")
        .select(
          `
          *,
          team_a:team_a_id(name, logo_url),
          team_b:team_b_id(name, logo_url)
        `,
        )
        .eq("tournament_id", turnirId)
        .eq("bracket_slot_id", finalSlotId)
        .maybeSingle();

      // Dohvaćamo timove za backup imena
      const { data: timoviData } = await supabase
        .from("turniri_timovi")
        .select("id, name, turnir_id, tournament_id");

      const timoviMap = new Map((timoviData || []).map((t) => [t.id, t.name]));

      // Pobjednik se prikazuje SAMO ako je finale odigrano i označeno sa is_completed: true
      if (finalMatchData && finalMatchData.is_completed) {
        let dynamicWinner = null;

        if (finalMatchData.scorea > finalMatchData.scoreb) {
          dynamicWinner =
            finalMatchData.team_a?.name ||
            timoviMap.get(finalMatchData.team_a_id);
        } else if (finalMatchData.scoreb > finalMatchData.scorea) {
          dynamicWinner =
            finalMatchData.team_b?.name ||
            timoviMap.get(finalMatchData.team_b_id);
        }

        if (dynamicWinner) {
          setTournamentWinner(dynamicWinner);
        }
      }

      // 3. DOHVAĆANJE UTAKMICE UŽIVO
      let liveData = null;
      let isVet = false;

      const { data: regularLive } = await supabase
        .from("turniri_utakmice")
        .select(`*, team_a:team_a_id(*), team_b:team_b_id(*)`)
        .eq("tournament_id", turnirId)
        .eq("is_live", true)
        .maybeSingle();

      if (regularLive) {
        liveData = regularLive;
        isVet = false;
      } else {
        const { data: veteranLive } = await supabase
          .from("turniri_veterani")
          .select(`*, team_a:team_a_id(*), team_b:team_b_id(*)`)
          .eq("tournament_id", turnirId)
          .eq("is_live", true)
          .maybeSingle();

        if (veteranLive) {
          liveData = veteranLive;
          isVet = true;
        }
      }

      if (liveData) {
        const preparedData = {
          ...liveData,
          isVeteran: isVet,
          rostera:
            liveData.rostera?.length > 0
              ? liveData.rostera
              : liveData.team_a?.players || [],
          rosterb:
            liveData.rosterb?.length > 0
              ? liveData.rosterb
              : liveData.team_b?.players || [],
        };
        setMatch(preparedData);
      } else {
        setMatch(null);
      }

      setLoading(false);
    };

    fetchLiveMatch();

    const channelUtakmice = supabase
      .channel(`realtime-home-live-utakmice-${turnirId}`)
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "turniri_utakmice" },
        (payload) => {
          if (payload.new && payload.new.tournament_id === turnirId) {
            // Ažuriramo direktno match state samo s novim podacima (rezultat, eventi, poluvrijeme)
            setMatch((prev) => {
              if (!prev || prev.id !== payload.new.id) return prev;
              return {
                ...prev,
                scorea: payload.new.scorea,
                scoreb: payload.new.scoreb,
                half: payload.new.half,
                events: payload.new.events,
                is_live: payload.new.is_live,
              };
            });
          }
        },
      )
      .subscribe();

    const channelVeterani = supabase
      .channel(`realtime-home-live-veterani-${turnirId}`)
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "turniri_veterani" },
        (payload) => {
          if (payload.new && payload.new.tournament_id === turnirId) {
            setMatch((prev) => {
              if (!prev || prev.id !== payload.new.id) return prev;
              return {
                ...prev,
                scorea: payload.new.scorea,
                scoreb: payload.new.scoreb,
                half: payload.new.half,
                events: payload.new.events,
                is_live: payload.new.is_live,
              };
            });
          }
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channelUtakmice);
      supabase.removeChannel(channelVeterani);
    };
  }, [turnirId]);

  // --- TIMER LOGIKA ZA ODBROJAVANJE S HRVATSKOM GRAMATIKOM ---
  useEffect(() => {
    if (!countdownData.enabled || !countdownData.target) return;

    const getDaysLabel = (d) => {
      if (d % 10 === 1 && d % 100 !== 11) return "DAN";
      if ([2, 3, 4].includes(d % 10) && ![12, 13, 14].includes(d % 100))
        return "DANA";
      return "DANA";
    };

    const getHoursLabel = (h) => {
      if (h % 10 === 1 && h % 100 !== 11) return "SAT";
      if ([2, 3, 4].includes(h % 10) && ![12, 13, 14].includes(h % 100))
        return "SATA";
      return "SATI";
    };

    const getMinutesLabel = (m) => {
      if (m % 10 === 1 && m % 100 !== 11) return "MINUTA";
      if ([2, 3, 4].includes(m % 10) && ![12, 13, 14].includes(m % 100))
        return "MINUTE";
      return "MINUTA";
    };

    const getSecondsLabel = (s) => {
      if (s % 10 === 1 && s % 100 !== 11) return "SEKUNDA";
      if ([2, 3, 4].includes(s % 10) && ![12, 13, 14].includes(s % 100))
        return "SEKUNDE";
      return "SEKUNDI";
    };

    const calculateTime = () => {
      const targetTime = new Date(countdownData.target).getTime();
      const currentTime = new Date().getTime();

      const difference = targetTime - currentTime;

      if (difference <= 0) {
        setTimeLeft(null);
        return;
      }

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      const h = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const m = Math.floor((difference / 1000 / 60) % 60);
      const s = Math.floor((difference / 1000) % 60);

      setTimeLeft({
        days: String(d).padStart(2, "0"),
        daysLabel: getDaysLabel(d),
        hours: String(h).padStart(2, "0"),
        hoursLabel: getHoursLabel(h),
        minutes: String(m).padStart(2, "0"),
        minutesLabel: getMinutesLabel(m),
        seconds: String(s).padStart(2, "0"),
        secondsLabel: getSecondsLabel(s),
      });
    };

    calculateTime();
    const interval = setInterval(calculateTime, 1000);
    return () => clearInterval(interval);
  }, [countdownData]);

  if (loading) return <LoaderBox text="Provjeravam utakmice uživo..." />;

  // --- 1. PROVJERA: AKO JE TURNIR ZAVRŠIO (PRIKAŽI POBJEDNIKA) ---
  if (tournamentWinner) {
    return (
      <div className="home-countdown-screen tournament-finished-screen">
        <div className="countdown-glass-card finished-card">
          <div className="countdown-header-zone">
            <div className="countdown-live-pulse">🏆 TURNIR JE ZAVRŠEN</div>
            <h2 className="countdown-main-title" style={{ marginTop: "15px" }}>
              Hvala vam!
            </h2>
            <p className="countdown-sub-title">
              Turnir je službeno priveden kraju. Hvala svim ekipama, navijačima
              i sponzorima koji su bili dio ove priče!
            </p>
          </div>

          <div className="winner-announcement-box">
            <span
              style={{
                color: "#8fa0ba",
                textTransform: "uppercase",
                fontSize: "0.85rem",
                letterSpacing: "1px",
              }}
            >
              Osvajač turnira
            </span>
            <h1
              style={{
                color: "#fff",
                fontSize: "2.2rem",
                margin: "5px 0 0 0",
                fontFamily: "Kanit",
                fontWeight: "700",
                textShadow: "0 0 20px rgba(0, 180, 255, 0.15)",
              }}
            >
              🥇 {tournamentWinner}
            </h1>
          </div>
        </div>
      </div>
    );
  }

  // --- 2. PROVJERA: AKO JE UKLJUČEN COUNTDOWN I POSTOJI VRIJEME ---
  if (countdownData.enabled && timeLeft) {
    return (
      <div className="home-countdown-screen">
        <div className="countdown-glass-card">
          <div className="countdown-header-zone">
            <div className="countdown-live-pulse">
              <span className="pulse-dot"></span>
              {tournamentName}
            </div>
            <h2 className="countdown-main-title">Turnir uskoro počinje</h2>
            <p className="countdown-sub-title">
              Ostalo je još vrlo malo do početka turnira. Spremite se!
            </p>
          </div>

          <div className="countdown-ticker-board">
            <div className="ticker-block">
              <div className="ticker-number">{timeLeft.days}</div>
              <div className="ticker-label">{timeLeft.daysLabel}</div>
            </div>
            <div className="ticker-divider">:</div>
            <div className="ticker-block">
              <div className="ticker-number">{timeLeft.hours}</div>
              <div className="ticker-label">{timeLeft.hoursLabel}</div>
            </div>
            <div className="ticker-divider">:</div>
            <div className="ticker-block">
              <div className="ticker-number">{timeLeft.minutes}</div>
              <div className="ticker-label">{timeLeft.minutesLabel}</div>
            </div>
            <div className="ticker-divider">:</div>
            <div className="ticker-block highlight-seconds">
              <div className="ticker-number">{timeLeft.seconds}</div>
              <div className="ticker-label">{timeLeft.secondsLabel}</div>
            </div>
          </div>

          <div className="countdown-footer-note">
            <i className="fi fi-rr-info"></i>
            Rezultati uživo, tablice i strijelci bit će dostupni čim turnir
            krene.
          </div>
        </div>
      </div>
    );
  }

  // --- 3. AKO NEMA UTAKMICE UŽIVO ---
  if (!match) {
    return (
      <div className="home-empty-state">
        <div className="empty-icon"></div>
        <h3>Trenutno nema utakmica uživo</h3>
        <p>Sve utakmice koje su u tijeku pojavit će se ovdje automatski.</p>
        <p>Provjerite raspored za nadolazeće utakmice.</p>
      </div>
    );
  }

  // --- 4. PRIKAZ UTAKMICE UŽIVO ---
  return (
    <div className="live-container">
      <div className="live-card">
        {match?.isVeteran && <div className="veterani-badge">VETERANI</div>}
        <div className="live-badge">
          <span className="dot"></span> UŽIVO
        </div>

        <div className="scoreboard">
          <div className="team">
            <img
              className="club-shield"
              src={match.team_a?.logo_url || ShieldImg}
              alt={match.team_a?.name || "Logo"}
              loading="lazy"
            />
            <span className="team-name">{match.team_a?.name}</span>
          </div>
          <div className="score">
            {match.scorea} : {match.scoreb}
          </div>
          <div className="team">
            <img
              className="club-shield"
              src={match.team_b?.logo_url || ShieldImg}
              alt={match.team_b?.name || "Logo"}
              loading="lazy"
            />
            <span className="team-name">{match.team_b?.name}</span>
          </div>
        </div>

        <div className="match-period">{match.half || "1. poluvrijeme"}</div>

        {(() => {
          const vA = match.votes_a || 0;
          const vB = match.votes_b || 0;
          const totalVotes = vA + vB;
          const percentA =
            totalVotes > 0 ? Math.round((vA / totalVotes) * 100) : 50;
          const percentB = totalVotes > 0 ? 100 - percentA : 50;

          return (
            <div className="vote-section-wrapper">
              <div className="vote-title">GLASAJ ZA SVOJ TIM</div>
              <div className={`vote-pill-bar ${hasVoted ? "voted" : ""}`}>
                <div
                  className="vote-side team-a-side"
                  onClick={() => !hasVoted && handleVote("A")}
                >
                  <span className="percent-text">{percentA}%</span>
                </div>

                <div className="vote-divider-line"></div>

                <div
                  className="vote-side team-b-side"
                  onClick={() => !hasVoted && handleVote("B")}
                >
                  <span className="percent-text">{percentB}%</span>
                </div>

                {/* Dinamički obojani dio u sredini koji se širi ovisno o postotku */}
                <div
                  className="vote-fill-indicator"
                  style={{ width: `${percentA}%` }}
                ></div>
              </div>

              {/* Nazivi timova s ugrađenom zaštitom protiv prelijevanja */}
              <div className="vote-team-names">
                <div
                  className="team-text-left"
                  title={match.team_a?.name || "Tim A"}
                >
                  {match.team_a?.name || "Tim A"}
                </div>
                <div
                  className="team-text-right"
                  title={match.team_b?.name || "Tim B"}
                >
                  {match.team_b?.name || "Tim B"}
                </div>
              </div>
            </div>
          );
        })()}
        <div className="timeline">
          {match.events && match.events.length > 0 ? (
            match.events
              ?.slice()
              .sort((a, b) => parseInt(a.time) - parseInt(b.time))
              .map((e, index) => (
                <div
                  key={index}
                  className={`event-row ${e.team === "A" ? "left" : "right"}`}
                >
                  <div className="event-content">
                    <span className="time">{e.time}'</span>
                    <EventIcon type={e.type} />
                    <span className="player">{e.player}</span>
                  </div>
                  <div className="center-line"></div>
                </div>
              ))
          ) : (
            <p className="no-events-text"></p>
          )}
        </div>
        <h5>Popis igrača:</h5>
        <div className="players-list-actions">
          <button
            className={activeRoster === "A" ? "active" : ""}
            onClick={() => setActiveRoster(activeRoster === "A" ? null : "A")}
          >
            {match.team_a?.name || "Tim A"}
          </button>
          <button
            className={activeRoster === "B" ? "active" : ""}
            onClick={() => setActiveRoster(activeRoster === "B" ? null : "B")}
          >
            {match.team_b?.name || "Tim B"}
          </button>
        </div>

        {activeRoster && (
          <div className="players-list shadow-effect">
            <h4>
              Sastav:{" "}
              {activeRoster === "A" ? match.team_a?.name : match.team_b?.name}
            </h4>
            {(activeRoster === "A" ? match.rostera : match.rosterb)
              ?.slice()
              .sort((a, b) => parseInt(a.no) - parseInt(b.no))
              .map((p, i) => (
                <div key={i} className="player-row">
                  <span className="number">{p.no}</span>
                  <span className="name">{p.name}</span>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

const EventIcon = ({ type }) => {
  switch (type) {
    case "goal":
      return (
        <div className="goal-icon" title="Gol">
          <i className="fi fi-br-football"></i>
        </div>
      );
    case "penalty":
      return (
        <div className="penalty-icon" title="Penal">
          <i className="fi fi-br-football"></i>
        </div>
      );
    case "penalty-miss":
      return (
        <div className="penalty-icon miss" title="Promašaj">
          <i className="fi fi-rs-cross-small"></i>
        </div>
      );
    case "yellow":
      return (
        <div className="two-min-out-icon" title="2 min">
          <p>2</p>
          <span>min</span>
        </div>
      );
    case "og":
      return (
        <div className="autogoal" title="Autogol">
          AG
        </div>
      );
    default:
      return <div className="c-icon c-default">?</div>;
  }
};

export default HomeLive;
